import { Select as MuiSelect, SelectProps, styled } from '@mui/material'

export const Select = styled((props: Omit<SelectProps, 'variant'>) => (
  <MuiSelect
    variant='outlined'
    MenuProps={{ className: props.className }}
    {...props}
  />
))`
  &.MuiOutlinedInput-root {
    color: #ffffff;
    border-radius: 4px;
  }

  & .MuiOutlinedInput-input.MuiSelect-select {
    font-size: 16px;
    line-height: 18px;
    min-height: 18px;
    padding: 9px 24px;
  }

  & .MuiSelect-select.MuiSelect-select.MuiSelect-select {
    padding-right: 40px;
  }

  & .MuiSelect-icon {
    height: 100%;
    width: auto;
    aspect-ratio: 1;
    filter: invert(95%);
    top: 0;
    right: 0;
  }

  &,
  &.Mui-focused {
    .MuiOutlinedInput-notchedOutline {
      border-width: 0px;
    }
  }

  & .MuiPaper-root {
    background-color: #161616;
    color: #ffffff;
    font-size: 16px;
    line-height: 20px;
    margin-top: 1px;
  }

  & .MuiList-root {
    padding: 0 5px;
  }
`
